export interface Filter {
  name: string
  condition?: string
  value?: any
  type: FilterTypes
  hidden?: boolean
  span?: number
  width?: string
  placeholder?: string
  label?: {
    col?: number
    text: string
  }
  input?: {
    placeholder?: string
  }
  checkboxGroup?: {
    items: Item[]
  }
  radio?: {
    items: Item[]
  }
  select?: SelectOptions
}

export enum FilterTypes {
  INPUT,
  CHECKBOX,
  CHECKBOX_GROUP,
  RADIO,
  DATE_PICKER,
  RANGE_PICKER,
  TIME_PICKER,
  SELECT
}

export interface Item {
  label: string
  value: string | number
}

export interface SelectOptions {
  multiple?: boolean
  items?: any
  ajax?: Ajax
}

export interface Ajax {
  url: string
  queryName: string
  idField: string
  textField: string
  preload?: boolean
  queryHandler?: Function
  resultHandler?: Function
}

export interface queryParams {
  filter?: {
    [entity: string]: {
      [operator: string]: any
    }
  }
}
